import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import React, { useEffect, useState } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import { createPortal } from 'react-dom';

import Hero from '../Hero/Hero';
import Search from '../Search/Search';
import Categories from '../Categories/Categories';
import PopularQuestionsList from '../PopularQuestionsList/PopularQuestionsList';
import QuestionModal from '../QuestionModal/QuestionModal';

function QuestionPage() {
  const { formatMessage } = React.useContext(NuDsContext);
  const question = formatMessage({ id: 'cms.question' });

  const [isOpen, setIsOpen] = useState(true);

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // This code will only execute in the browser environment
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }
    }
  }, [isOpen]);

  return (
    <Box>
      <Hero />
      <Search />
      <Categories />
      <PopularQuestionsList />

      {/* QUESTION MODAL OPEN */}

      {isOpen && typeof document !== 'undefined' && question && createPortal(
        <QuestionModal
          closeModal={closeModal}
          title={question.question}
          answer={question.answer}
        />, document.getElementById('modal-root'),
      )}

    </Box>
  );
}

export default QuestionPage;
